import { type ProposalEngagement } from './proposalEngagement.models';

export interface ProposalEngagementState {
  ids: string[];
  entities: Record<string, ProposalEngagement>;
  loadingProposalIds: string[];
}

export const initState: ProposalEngagementState = {
  ids: [],
  entities: {},
  loadingProposalIds: [],
};

export type ProposalEngagementAction =
  | { type: 'FETCH_PROPOSAL_ENGAGEMENTS'; payload: { proposalIds: string[] } }
  | {
      type: 'FETCH_PROPOSAL_ENGAGEMENTS_SUCCESS';
      payload: { proposalIds: string[]; engagements: ProposalEngagement[] };
    }
  | {
      type: 'FETCH_PROPOSAL_ENGAGEMENTS_FAILURE';
      payload: { proposalIds: string[] };
    };

export const proposalEngagementReducer = (
  state: ProposalEngagementState,
  action: ProposalEngagementAction
): ProposalEngagementState => {
  switch (action.type) {
    case 'FETCH_PROPOSAL_ENGAGEMENTS':
      return {
        ...state,
        loadingProposalIds: [
          ...new Set([
            ...state.loadingProposalIds,
            ...action.payload.proposalIds,
          ]),
        ],
      };
    case 'FETCH_PROPOSAL_ENGAGEMENTS_SUCCESS':
      return {
        ...state,
        ids: [
          ...new Set([
            ...state.ids,
            ...action.payload.engagements.map((e) => e.proposalId),
          ]),
        ],
        entities: action.payload.engagements.reduce(
          (prev, curr) => ({ ...prev, [curr.proposalId]: curr }),
          state.entities
        ),
        loadingProposalIds: state.loadingProposalIds.filter(
          (id) => !action.payload.proposalIds.includes(id)
        ),
      };
    case 'FETCH_PROPOSAL_ENGAGEMENTS_FAILURE':
      return {
        ...state,
        loadingProposalIds: state.loadingProposalIds.filter(
          (id) => !action.payload.proposalIds.includes(id)
        ),
      };
    default:
      return state;
  }
};
